import React, { useState } from 'react'
import {
  PAGINATION_DEFAULT,
  PerformanceEvaluationStatusConfig,
} from '../../utils/constants'
import { useGetEvaluations } from '../../redux/human-resources/hook/performance'
import DataTable from '../datatable'
import ViewEvaluation from './ViewEvaluation'

const Evaluations = () => {
  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    search: '',
  })
  const [viewEvaluation, setViewEvaluation] = useState(false)
  const [assessmentData, setAssessmentData] = useState()

  const { data: evaluations } = useGetEvaluations(
    pagination?.limit,
    pagination?.page,
    pagination?.search
  )

  const tableConfig = {
    headers: ['Employee Name', 'Period Covered'],
    keys: ['employeeName', 'period'],
    mobileHeader: {
      left: {
        title: 'Employee Name',
        key: 'employeeName',
      },
      right: {
        title: 'Period Covered',
        key: 'period',
      },
    },
  }

  const actionConfig = [
    {
      name: 'View',
      color: 'green',
      action: (id) => {
        let index = evaluations.data.findIndex((item) => item.id === id)
        setAssessmentData(evaluations.data?.[index])
        setViewEvaluation(true)
      },
    },
  ]
  return (
    <div>
      {viewEvaluation ? (
        <ViewEvaluation
          isOpen={viewEvaluation}
          closeModal={() => setViewEvaluation(false)}
          assessmentData={assessmentData}
        />
      ) : null}
      <hr className='divider mt-0 mb-2' />
      <DataTable
        data={evaluations}
        tableConfig={tableConfig}
        actionConfig={actionConfig}
        computedActions={true}
        updatePagination={(data) => setPagination(data)}
        noCheck={true}
        statusConfig={PerformanceEvaluationStatusConfig}
      />
    </div>
  )
}

export default Evaluations
